import staticSuggestions from './static-suggestions';

export default [
    {
        token: '@',
        regex: /^(@)(.+)$/g,
        resourceMask: (matchedWord, self) => {
            const [match, token, id] = self.regex.exec(matchedWord);
            return {
                match,
                token,
                name: 'users',
                id,
            };
        },
        staticValues: staticSuggestions['@'],
        resources: {
            users: {
                name: 'users',
                icon: 'at',
                entityPickerMask: ({email}) => `@${email}`,
                entityValueMask: ({email}) => `@${email}`,
            },
        },
    },
    {
        token: '#',
        regex: /^(#)(\w+)(-)(.+)/g,
        resourceMask: (matchedWord, self) => {
            const [match, token, name, , id] = self.regex.exec(matchedWord);
            return {
                match, token, name, id,
            };
        },
        divider: '-',
        resources: {
            customers: {
                name: 'customers',
                icon: 'customers',
                resourceRouteMask:
                    resource => ({name: 'customer-details', params: {id: resource.id}}),
                entityPickerMask: entity => `${entity.id}`,
                entityValueMask: entity => `#customers-${entity.id}`,
            },
            transactions: {
                name: 'transactions',
                icon: 'transactions',
                resourceRouteMask:
                    resource => ({name: 'transaction-details', params: {id: resource.id}}),
                entityPickerMask: entity => `${entity.id}`,
                entityValueMask: entity => `#transactions-${entity.id}`,
            },
        },
    },
];
